<template>
  <div>
    <VueDatePicker
      no-calendar-icon
      no-header
      format="DD/MM/YYYY"
      v-if="type == 'range'"
      v-model="date"
      class="full-width"
      range
      clearable
      fullscreen-mobile
      placeholder="Choose date"
      @onChange="showConsoleMessage()"
      ><template #activator="{ date }">
        <button
          class="button is-small borderColor"
          ref="activator"
          type="button"
          :disabled="loading"
        >
          <p :class="!date ? 'has-text-grey-light' : 'has-text-dark'">
            {{ !date ? "Choose date" : date }}
          </p>
        </button>
      </template>
    </VueDatePicker>

    <VueDatePicker
      no-calendar-icon
      no-header
      format="DD/MM/YYYY"
      v-if="type == 'day'"
      placeholder="Choose date"
      v-model="day"
      class="full-width p-0"
      fullscreen-mobile
      clearable
      @onChange="showConsoleMessage()"
      :allowed-dates="
        disableDate && disableDate.length > 0 ? allowedDates : null
      "
    >
      <template #activator="{ date }">
        <button
          class="button is-small"
          ref="activator"
          type="button"
          :disabled="loading"
        >
          <p :class="!date ? 'has-text-grey-light' : 'has-text-dark'">
            {{ !date ? "Choose date" : date }}
          </p>
        </button>
      </template>
    </VueDatePicker>
  </div>
</template>

<script>
import { VueDatePicker } from "@mathieustan/vue-datepicker";
import "@mathieustan/vue-datepicker/dist/vue-datepicker.min.css";

export default {
  name: "InputCalender",
  props: ["value", "change", "type", "loading", "disableDate"],
  components: {
    VueDatePicker,
  },
  data() {
    return {
      day: !this.value ? null : this.value,
      date: {
        start: !this.value.start ? "" : this.value.start,
        end: !this.value.end ? "" : this.value.end,
      },
      currentDate: this.date,
    };
  },
  watch: {
    value() {
      this.day = !this.value ? null : this.value;
      this.date = {
        start: !this.value.start ? "" : this.value.start,
        end: !this.value.end ? "" : this.value.end,
      }
    },
  },
  computed: {
    minDate() {
      return new Date(
        this.currentDate.getFullYear() - 1,
        this.currentDate.getMonth(),
        this.currentDate.getDate()
      );
    },
    maxDate() {
      return new Date(
        this.currentDate.getFullYear() + 1,
        this.currentDate.getMonth(),
        this.currentDate.getDate()
      );
    },
  },
  methods: {
    allowedDates(val) {
      let array = this.disableDate;
      return array.find((item) => item == val) == undefined && val;
    },
    showConsoleMessage() {
      if (this.type == "range") {
        this.change(this.type, this.date);
      } else {
        this.change(this.type, this.day);
      }
    },
  },
};
</script>

<style>
.vd-wrapper {
  background-color: white;
  border-color: rgb(100 121 143 / 12%) !important;
  border-width: 1px;
  color: #363636;
  cursor: pointer;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  /* padding-bottom: calc(0.5em - 1px); */
  /* padding-left: 0px;
  padding-right: 0px; */
  border-radius: 4px;
  /* padding-top: calc(0.5em - 1px); */
  text-align: center;
}

.vd-wrapper .vd-activator button {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: block;
}
.full-width {
  width: 100%;
}

.vd-wrapper.full-width .vd-activator button {
  width: 100%;
}
</style>


// WEBPACK FOOTER //
// src/components/OverallReporting/InputCalender.vue